import { SearchOptionType, type SearchOptions } from 'gpcore-grpc/gpcore/type/v1/search_pb';
import { type Ref, computed } from 'vue';

export default (
  searchData: Record<string, string | number | boolean | null>,
  searchOptions: Ref<SearchOptions>,
) => {
  const getInvalidMessage = (name: string) => {
    if (searchData[name] == null) {
      return '';
    }

    const option = searchOptions.value.options.find((o) => o.name === name);
    if (option.validationRegex == null) {
      return '';
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, regex, options] = option.validationRegex.split('/');

    const regExp = new RegExp(regex, options);
    switch (option.type) {
      case SearchOptionType.STRING:
        return !regExp.test(searchData[name] as string)
          ? `Filter value does not match regex "${option.validationRegex}".`
          : '';
      case SearchOptionType.DROPDOWN:
        return !Object.keys(option.dropdownValues)
          .map((entry) => entry[0])
          .includes(searchData[name] as string)
          ? `Filter value "${searchData[name]}" is not a valid dropdown option.`
          : '';

      case SearchOptionType.BOOLEAN:
        return typeof searchData[name] !== 'boolean'
          ? `Filter value "${searchData[name]}" is not a valid boolean.`
          : '';
      default:
        return '';
    }
  };

  const isOptionValid = (name: string) => getInvalidMessage(name) === '';

  const isFormValid = computed(() => Object.keys(searchData).every((key) => isOptionValid(key)));

  return {
    getInvalidMessage,
    isOptionValid,
    isFormValid,
  };
};
